import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class Team extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "name", Model.attribute('name'));
    _defineProperty(this, "logoUrl", Model.attribute('logoUrl'));
    _defineProperty(this, "externalId", Model.attribute('externalId'));
    _defineProperty(this, "isActive", Model.attribute('isActive'));
  }
  apiEndpoint() {
    return '/nagusi/match-ratings/teams' + (this.exists ? '/' + this.data.id : '');
  }
}
flarum.reg.add('nagusi-match-ratings', 'common/models/Team', Team);